<template>
	<div
		class="flex flex-col items-center bg-(image:--info-gradient) transition-opacity duration-300"
		:class="{ 'opacity-0': !show }"
	>
		<div
			class="text-label-primary text-xs font-medium uppercase transition-all duration-500"
			:class="{ 'translate-y-1/2 opacity-0': !show }"
		>
			{{ collectionName }}
		</div>
		<div
			class="text-sm font-semibold uppercase transition-all duration-400"
			:class="{
				'text-orange': color === 'orange',
				'text-pink-dark': color === 'red',
				'text-pink': color === 'pink',
				'text-blue': color === 'blue',
				'translate-y-1/2 opacity-0': !show
			}"
		>
			{{ modelName }}
		</div>
		<CoinPrice
			class="mt-1.5 transition-all duration-300"
			:class="{ 'translate-y-1/2 opacity-0': !show }"
			size="md"
			:minDigits="2"
			:digits="2"
			:price="amount"
			mono
		/>
	</div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import CoinPrice from './CoinPrice.vue'
import { sleep } from '@/utils/sleep'

const props = defineProps<{
	collectionName: string
	modelName: string
	price: number
	color: 'orange' | 'pink' | 'red' | 'blue'
}>()

const amount = ref(0)

let start = 0
const createAnimationFrame = (from: number, to: number, duration: number) => {
	start = performance.now()
	const animate = (current: number) => {
		const progress = (current - start) / duration
		amount.value = from + (to - from) * progress * (2 - progress)
		if (progress < 1) {
			requestAnimationFrame(animate)
		} else {
			amount.value = to
		}
	}
	requestAnimationFrame(animate)
}

const show = ref(false)

onMounted(async () => {
	await sleep(50)
	show.value = true

	const from = 0
	const to = props.price
	createAnimationFrame(from, to, 500)
})
</script>
